import type { JSX } from 'react';
import { MessageDescriptor } from 'react-intl';

export function accountFAQ(
	messages: Record<string, MessageDescriptor>,
	faqCount: number,
	placeholders?: { [key: string]: string | number | boolean | (() => JSX.Element) },
): Array<{
	trigger: MessageDescriptor;
	children: MessageDescriptor;
	id: number;
}> {
	const faqs = [];

	for (let i = 1; i <= faqCount; i++) {
		const questionKey = `faq${i}Question`;
		const answerKey = `faq${i}Answer`;
		faqs.push({
			id: i,
			trigger: messages[questionKey],
			children: messages[answerKey],
			placeholders,
		});
	}
	return faqs;
}
